module.exports = __webpack_public_path__ + "img/11.f87c5f13.jpg";